import React, { useContext, useState } from 'react'
import Head from 'next/head'
import { register } from 'src/lib/auth-api'
import { AuthContext } from 'src/component/Context/AuthContext'
import RegisterForm from 'src/component/Pages/Register'

export default function LoginPage() {
  const [loading, setLoading] = useState(false)
  const [errorMessage, setErrorMessage] = useState(false)
  const [success, setSuccess] = useState(false)
  const [validation, setValidation] = useState({})
  const {
    auth: { loginForms },
    dispatch
  } = useContext(AuthContext)

  const updateForm = (e) => {
    const value =
      e.target.type === 'checkbox' ? e.target.checked : e.target.value

    dispatch({ type: 'SET_FORM', key: e.target.name, value })
  }

  const handleSubmit = async (e) => {
    e.preventDefault()

    if (loading || success) return

    setLoading(true)

    try {
      const status = await register(loginForms)
      setSuccess(status.success)
    } catch (e) {
      if (e.validation) {
        setErrorMessage('Please check the form for errors and try again.')
        setValidation(e.errors)
      } else {
        if (e.response && e.response.errors) {
          setErrorMessage(e.response.errors[0].message)
        } else {
          setErrorMessage(e.message)
        }
        setValidation({})
      }
    }

    setLoading(false)
  }

  return (
    <>
      <Head>
        <title>Register - Citygate Portal</title>
      </Head>
      <RegisterForm
        onSubmit={handleSubmit}
        error={errorMessage}
        validation={validation}
        loading={loading}
        formData={loginForms}
        onChange={updateForm}
        success={success}
      />
    </>
  )
}
